import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import {
  defaultConfig,
  generateHeaders,
  makeNormalizeResponse,
} from 'serviceWorker/helpers/httpRequests';
import { pull } from '../pull';
import { DirectoryInDto } from 'shared/dtos/in/directory';
import {
  HeadersData,
  NormalizedEntityResponseData,
} from '../factories/types';

const parseResponse = makeNormalizeResponse<DirectoryInDto>('items');

export const fetchDirectories = (
  data: HeadersData,
  controller: AbortController
): Promise<NormalizedEntityResponseData<DirectoryInDto>> | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/dir`;

  return pull(builtUrl, {
    ...defaultConfig,
    cache: 'default',
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parseResponse);
};

export const fetchUpdatedDirectories = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
): Promise<NormalizedEntityResponseData<DirectoryInDto>> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    //not enough data, skip.
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/dir?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'directories'))
    .then(parseResponse);
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
